import styled from 'styled-components';

export const ToDoWrapper = styled.div`
    --ac-text: #1F2A37;
    --ac-muted: #6B7A8F;
    --ac-disabled: #8A97A8;
    --ac-border: #E3E8EF;
    --ac-border-soft: #EEF1F5;
    --ac-hover: #F3F5F8;
    --ac-urgent-bg: #CE0E2D;
    --ac-urgent-fg: #FFFFFF;
    --ac-urgent-soft-bg: #FBE4E8;
    --ac-urgent-soft-fg: #A30B24;
    --ac-compliance-bg: #FFF1DE;
    --ac-compliance-fg: #9A4B00;

    max-width: 520px;

    .ac-card {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        background: #FFFFFF;
        border: 1px solid var(--ac-border);
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
        overflow: hidden;
    }

    .ac-card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 20px;
        border-bottom: 1px solid var(--ac-border-soft);
        cursor: pointer;
        user-select: none;
    }

    .ac-card-header h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: var(--ac-text);
    }

    .ac-card-header .ac-card-subtitle {
        font-size: 12px;
        color: var(--ac-muted);
    }

    .ac-card-header .ac-card-spacer {
        flex-grow: 1;
    }

    .ac-card-icon {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .ac-card-icon > .glyphicon {
        top: 0;
        font-size: 15px;
    }

    .ac-pill {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 22px;
        padding: 0 8px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
    }

    .ac-card.ac-urgent .ac-card-icon { background: var(--ac-urgent-soft-bg); color: var(--ac-urgent-soft-fg); }
    .ac-card.ac-urgent .ac-pill { background: var(--ac-urgent-bg); color: var(--ac-urgent-fg); }
    .ac-card.ac-compliance .ac-card-icon,
    .ac-card.ac-compliance .ac-pill { background: var(--ac-compliance-bg); color: var(--ac-compliance-fg); }

    .ac-card-toggle {
        width: 32px;
        height: 32px;
        padding: 0;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: #5B6B7F;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ac-card-toggle:hover,
    .ac-card-toggle:focus {
        background: var(--ac-hover);
        outline: none;
    }

    .ac-card-toggle > .glyphicon {
        top: 0;
    }

    .ac-card-body {
        padding: 12px;
    }

    .ac-card-collapsed {
        padding: 10px 20px;
        font-size: 12px;
        color: var(--ac-muted);
    }

    .ac-card-collapsed:after {
        content: 'Click the header to expand';
    }

    .ac-empty {
        padding: 10px;
        font-size: 14px;
        color: var(--ac-muted);
    }

    .ac-item {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        min-height: 44px;
        padding: 6px 10px;
        border: none;
        border-radius: 8px;
        background: transparent;
        text-align: left;
        color: var(--ac-text);
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .ac-item:hover,
    .ac-item:focus {
        background: var(--ac-hover);
        outline: none;
    }

    .ac-item:disabled {
        color: var(--ac-disabled);
        font-weight: 400;
        cursor: default;
    }

    .ac-item:disabled:hover {
        background: transparent;
    }

    .ac-item > .ac-pill {
        min-width: 34px;
        height: 24px;
        flex-shrink: 0;
    }

    .ac-item:disabled > .ac-pill {
        background: #FFFFFF;
        border: 1px solid #D5DBE3;
        color: var(--ac-disabled);
        font-weight: 600;
    }

    .ac-item > .ac-item-label {
        flex-grow: 1;
        line-height: 1.3;
    }

    @media (max-width: 1823px) {
        .ac-item {
            font-size: 12px;
            min-height: 40px;
        }

        .ac-card-header h4 {
            font-size: 14px;
        }
    }
`;
